import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Operations extends Vue {
  calculatePercentage (total: number, value: number) {
    return (value * 100) / total
  }
}
